module.exports = "img/photo14.967ee2.jpg";